<script>
  import {HorizontalBar} from 'vue-chartjs';

  export default {
    name: "horizontalGroupedBarChart",
    extends: HorizontalBar,
    props: {
      data: {
        type: Object,
        default: null,
      },
      options: {
        type: Object,
        default: null
      }
    },
    watch: {
      data: {
        handler() {
          if (this.data.datasets.length) {
            this.renderChart(this.data, this.options)
          }
        }
      }
    },
    mounted() {
      if (this.data) {
        this.renderChart(this.data, this.options)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Wrappers/horizontalGroupedBarChart.vue